import React from "react";
import { Box, Typography, Button } from "@mui/material";

const BlanccoSection: React.FC = () => {
    return (
        <Box sx={{ py: { xs: 2, md: 6 }, background: '#fff' }}>
            <Box sx={{ maxWidth: { xs: '100%', md: '50%' }, mx: 'auto' }}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', md: 'row' },
                        borderRadius: { xs: 2, md: 3 },
                        overflow: 'hidden',
                        background: '#f5f5f5',
                    }}
                >
                    {/* 왼쪽 텍스트 영역 */}
                    <Box
                        sx={{
                            flex: { md: '0 0 50%' },
                            p: { xs: 2.5, sm: 4, md: 5 },
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                        }}
                    >
                        <Box
                            component="img"
                            src="/assets/blancco_logo.png"
                            alt="Blancco"
                            sx={{
                                height: { xs: 28, md: 38 },
                                width: 'auto',
                                objectFit: 'contain',
                                alignSelf: 'flex-start',
                                mb: { xs: 2, md: 3 },
                            }}
                        />

                        <Typography
                            fontWeight={600}
                            sx={{
                                fontSize: { xs: '1rem', sm: '1.15rem', md: '1.35rem' },
                                color: '#1a1a2e',
                                lineHeight: 1.7,
                                mb: { xs: 2.5, md: 3 },
                            }}
                        >
                            단순 공장 초기화가 아닙니다.<br />
                            복.구.불.가. 데이터 삭제 솔루션입니다.
                        </Typography>

                        <Box>
                            <Button
                                variant="contained"
                                href="/trust"
                                sx={{
                                    borderRadius: 50,
                                    px: { xs: 3, md: 3.5 },
                                    py: { xs: 0.8, md: 1 },
                                    fontWeight: 600,
                                    fontSize: { xs: '0.8rem', md: '0.85rem' },
                                    background: '#1a73e8',
                                    textTransform: 'none',
                                    boxShadow: 'none',
                                    '&:hover': {
                                        background: '#1557b0',
                                        boxShadow: 'none',
                                    },
                                }}
                            >
                                자세히 보기
                            </Button>
                        </Box>
                    </Box>

                    {/* 오른쪽 이미지 영역 */}
                    <Box
                        sx={{
                            flex: { md: '0 0 50%' },
                            position: 'relative',
                            minHeight: { xs: 160, sm: 240, md: 280 },
                        }}
                    >
                        <Box
                            component="img"
                            src="/assets/blancco_erasure.jpg"
                            alt="Blancco Data Erasure Report"
                            sx={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                objectPosition: 'center',
                            }}
                        />
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default BlanccoSection;
